import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { Patologia } from '../atlas-patologia/atlas-patologia.modelview';
import { ImageViewerController } from 'ionic-img-viewer';

/**
 * Generated class for the DetalheAtlasPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-detalhe-atlas',
  templateUrl: 'detalhe-atlas.html',
})
export class DetalheAtlasPage {
  model: Patologia

  constructor(public navCtrl: NavController, public navParams: NavParams,public imageViewerCtrl: ImageViewerController) {
    this.model = navParams.get("model")
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad DetalheAtlasPage');
  }

  presentImage(myImage) {
    const imageViewer = this.imageViewerCtrl.create(myImage);
    imageViewer.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/detalhe-atlas/detalhe-atlas.ts